import { Checkbox } from '@rmwc/checkbox'
import React, { RefObject, useContext } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ProgressPage, FixedButtons } from 'components'
import { req } from 'global/common'
import { InterfaceContext } from 'global/context.interface'
import { UserContext } from 'global/context.user'
import { IOrganizationProfileDataRow } from './PublicOrganizationProfile.types'
import { dataColumns } from './PublicOrganizationProfile.service'
import './PublicOrganizationProfile.style.sass'

export function PublicOrganizationProfileTemplate() {
	const form: RefObject<HTMLFormElement> = React.createRef()
	const interfaceCTX = React.useContext(InterfaceContext)
	const [template, setTemplate] = React.useState(null as any)
	const userCTX = useContext(UserContext)
	const { t } = useTranslation('common')

	const methods = useForm({
		mode: 'all'
	})

	React.useEffect(() => {
		req
			.get(`/organisation/${userCTX!.user!.organisation.id}/fields-settings/get`)
			.then(data => {
				setTemplate(data.data)
			})
			.catch(e => {
				interfaceCTX.showMessage({
					title: 'Ошибка',
					body: t(e.response.data),
					icon: 'report'
				})
			})
		return () => {
			interfaceCTX.resetIsFormChanged()
		}
	}, [])

	function submitForm(data: any) {
		// console.log(new DataToSend(data))
		req
			.post(`/organisation/${userCTX!.user!.organisation.id}/fields-settings/update`, { hidden: template.hidden })
			.then(() => {
				interfaceCTX.resetIsFormChanged()
				interfaceCTX.showMessage({
					body: 'Данные успешно сохранены',
					icon: 'done'
				})
			})
			.catch(e => {
				interfaceCTX.showMessage({
					title: 'Ошибка',
					body: t(e.response.data),
					icon: 'report'
				})
			})
	}

	return (
		<div className='public-organization-profile-template'>
			<ProgressPage
				state={template}
				render={() => (
					<div className='public-organization-profile-template-inner'>
						<FormProvider {...methods}>
							<div className='form-wrapper'>
								<form ref={form} className='form' onSubmit={methods.handleSubmit(submitForm)}>
									<div className='form-columns-wrapper'>
										{/* <div className="Form-column"> */}
										{template &&
											dataColumns.map((dataColumn: IOrganizationProfileDataRow[]) => (
												<div className='form-column'>
													{dataColumn.map((dataItem: IOrganizationProfileDataRow) => (
														<div className='option-row'>
															<Controller
																key={dataItem.name + '_hidden'}
																control={dataItem.isAbleToBeHidden ? methods.control : undefined}
																name={dataItem.name + '_hidden'}
																defaultValue={!template.hidden[dataItem.name]}
																render={({ field, fieldState }) => {
																	let disabled = !dataItem.isAbleToBeHidden
																	return (
																		<>
																			<Checkbox
																				className='hidden'
																				onChange={e =>
																					setTemplate((v: any) => {
																						interfaceCTX.checkIsFormChanged(true, 'settings')
																						return {
																							...v,
																							hidden: {
																								...v.hidden,
																								[dataItem.name]: !e.currentTarget.checked
																							},
																							required: {
																								...v.required,
																								[dataItem.name]: false
																							}
																						}
																					})
																				}
																				disabled={disabled}
																				checked={
																					dataItem.isAbleToBeHidden == false ? true : !template.hidden[dataItem.name]
																				}
																				// value={template.hidden[dataItem.name]}
																				// {...field}
																			/>
																		</>
																	)
																}}
															/>
															<div className='option-title'>{dataItem.title}</div>
														</div>
													))}
												</div>
											))}
									</div>
								</form>
								<FixedButtons
									length={4}
									buttons={[
										{
											label: 'Сохранить',
											primary: true,
											onClick: () => {
												// e.preventDefault()
												form.current!.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
											}
										}
									]}
								/>
							</div>
						</FormProvider>
					</div>
				)}
			/>
		</div>
	)
}
